import isPlainObject from 'lodash-es/isPlainObject';
export function parseObjectStorageConfig(config) {
    if (isRecord(config)) {
        if (config.objectStorage !== undefined) {
            return {
                filePathPrefix: config.objectStorage.filePathPrefix,
            };
        }
    }
    return {};
}
function isRecord(obj) {
    return isPlainObject(obj);
}
//# sourceMappingURL=ObjectStorageConfiguration.js.map